import { ActivityWizardData } from "../types";

function todayISODate(): string {
  return new Date().toISOString().split("T")[0];
}

function dateOnly(d: string | null | undefined): string {
  if (!d) return "";
  return d.split("T")[0];
}

export function mapWizardDataToInputForm(data: ActivityWizardData): any {
  return {
    ...data,

    soft_expiring: false,
    expiration_date_flag: false,
    expected_compl_time: null,
    persona: [],
    //TODO detail_description deve essere popolata altrimenti be va in errore capire come risolvere
    detail_description: "d",
    note: "",
    knowledge_domain: null,
    format: null,
    learning_purpose: null,
    fixed_expiration: false,
    highlight_for_you: false,
    highlight_agenda: false,
    mandatory: false,
    status: undefined,
    expiration_date: null,
    phisical_edition: [],
    virtual_edition: [],

    fruition_flag: String(data.fruition_flag),
    download_flag: String(data.download_flag),

    credits: data.credits || undefined,
    useful_links:
      data.useful_links && data.useful_links.length > 0
        ? data.useful_links
        : undefined,

    publish_date: dateOnly(data.publish_date) || todayISODate(),
    obsolescent_date: dateOnly(data.obsolescent_date) || "9999-12-31",

    certificate_ids: data.certificate_ids?.map((c) => Number(c.id)) ?? [],
    signature_certificate_ids:
      data.signature_certificate_ids?.map((c) => Number(c.id)) ?? [],
    badge_id: data.badge_id ? Number(data.badge_id.id) : null,
    survey_id: data.survey_id ? Number(data.survey_id.id) : null,
  };
}
